import { useHistory } from "react-router";

import { Path } from "~/v2/path";
import { useAssetSearchController } from "./AssetSearch.controller";
import { AssetSearchPresentation } from "./AssetSearch.pres";
import type { AssetSearchProps } from "./AssetSearch.types";
import { AssetIcon } from "./assetIcon/AssetIcon.connector";

export const AssetSearch = (props: AssetSearchProps) => {
  const history = useHistory();

  const { containerRef, presentation } = useAssetSearchController({
    ...props,
    // Crypto symbols carry a slash (`BTC/USD`), which would split the path segment.
    onNavigate: (symbol) =>
      history.push(
        Path.format(Path.ROUTE_TRADE, { symbol: encodeURIComponent(symbol) }),
      ),
  });

  const assetIcons = Object.fromEntries(
    presentation.assets.map((asset) => [
      asset.symbol,
      <AssetIcon key={asset.symbol} name={asset.symbol} />,
    ]),
  );

  return (
    <div ref={containerRef}>
      <AssetSearchPresentation {...presentation} assetIcons={assetIcons} />
    </div>
  );
};
